module.exports = __webpack_public_path__ + "img/Archiv_2019.27349288.jpeg";